enum FlowType {
  Embedded = 'embedded',
  WebView = 'webview',
  Hosted = 'hosted',
  Inline = 'inline',
}
export default FlowType;
